<template>
  <transition name="fade">
    <div v-if="showing" class="modal" @click.self="close">
      <div class="modal-dialog relative bg-white shadow-lg rounded-lg sm:w-1/2 xl:w-1/3 pb-8">
        <button aria-label="close" class="btn-close" @click.prevent="close">
          <i class="far fa-times"></i>
        </button>
        <div class="w-10/12">
          <p class="text-primary text-2xl pt-8 pl-8 text-left">É necessário login para salvar esta publicação.  </p>
        </div>
        <p class="text-gray text-base text-left px-8 pt-8 ">Com a lista de itens salvos, você marca publicações que deseja ler mais tarde ou consultar regularmente.</p>
        <p class="text-right pt-8 pr-8">
          <a href="/acesso/autenticar" class="border rounded-lg border-primary text-base text-white bg-primary p-3 hover:bg-primary-300 hover:border-primary-300 mr-4">Acessar</a>
          <a href="/acesso/autenticar" class="border rounded-lg border-primary text-primary text-base p-3 hover:border-primary-300 hover:text-primary-300 pr-4">Quero me cadastrar</a>
        </p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ModalLogin",
  

  data: () => ({
    showing: false,
  }),

  methods: {
    open() {
      this.showing = true

      this.$nextTick(() => {
        this.$emit('open')
      })
    },

    close() {
      this.showing = false

      this.$nextTick(() => {
        this.$emit('close')
      })
    },
    
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.4s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.modal {
  @apply fixed;
  @apply z-10;
  @apply inset-0;
  @apply w-full;
  @apply h-auto;
  @apply flex;
  @apply items-center;
  @apply justify-center;
  @apply bg-gray-800;
  @apply bg-opacity-75;
  @apply p-32;

  &-dialog {
    height: auto;
    overflow-y: initial !important;

    .btn-close {
      @apply absolute;
      @apply top-0;
      @apply right-0;
      @apply m-4;

      @apply rounded-full;
      @apply h-10;
      @apply w-10;
      @apply bg-gray-900;
      @apply bg-opacity-75;

      @apply text-white;

      &:hover, &:focus {
        @apply bg-white;
        @apply bg-opacity-75;

        @apply text-gray;
      }
    }
  }

  &-body {
    height: 100%;

    iframe {
      border: 0;
      height: 100%;
      left: 0;
      top: 0;
      width: 100%;
    }
  }
}
</style>
